export default "__VITE_ASSET__d4257e2b__"